import React from "react";

export function MenuButton({
  onClick,
  danger,
  disabled,
  children,
}: {
  onClick:   () => void;
  danger?:   boolean;
  disabled?: boolean;
  children:  React.ReactNode;
}) {
  return (
    <button
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      disabled={disabled}
      className={`w-full text-left px-3 py-2 text-sm transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
        danger
          ? "text-red-600 hover:bg-red-50"
          : "text-gray-700 hover:bg-gray-50"
      }`}
    >
      {children}
    </button>
  );
}
